<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Add Courses To {{company.name}}</h4>
    <button class="btn-close py-0" type="button" (click)="close()"></button>
  </div>
  <div class="modal-body">
      <div class="row">
    <div class="row">
      <div class="col-12">
        <div class="col-form-label d-flex justify-content-between">
          Course
        </div>
      
        <ng-select  class="form-control" id="select" [items]="availableCourses"   bindLabel="name" bindValue="id" [(ngModel)]="selectedProduct"
          (change)="selectCourse($event)" >
        </ng-select>
        @if(validate && courseError){
        <span class="danger-color">{{courseError}}</span>
        }
      </div>
        <div class="col-4">
          <label class="col-form-label pt-0">Price</label>
          <input class="form-control" type="number" placeholder="Price" [value]="product.price"
            (input)="editPrice($event.target,product)" />
            @if(validate && priceError){
              <span class="danger-color">{{courseError}}</span>
            }
        </div>
        <div class="col-4">
          <label class="col-form-label pt-0">Quantity</label>
          <input class="form-control" type="number" placeholder="Quantity" (input)="editQuantity($event.target,product)"
            [value]="product.quantity" />
            @if(validate && quantityError){
              <span class="danger-color">{{courseError}}</span>
            }
        </div>
        <div class="col-4">
          <label class="col-form-label pt-0">Total</label>
          <input class="form-control" type="number" placeholder="Total" [value]="product.totalProduct" disabled/>
        </div>
      </div>
      <div class="row mt-2">
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary btn-block" type="button" (click)="addProduct()">
              Add
            </button>
          </div>
      </div>
    <br>
    <div class="table-responsive theme-scrollbar">
      <table class="w-100">
        <tbody>
          <tr>
            <th> Course</th>
            <th> Price</th>
            <th> Quantity</th>
            <th> Total</th>
            <th> Action</th>
          </tr>
          @for(product of order.products; track product;let idx = $index) {
          <tr>
            <td> {{product.productName}}</td>
            <td> {{product.price}}</td>
            <td> {{product.quantity}}</td>
            <td> {{product.totalProduct}}</td>
            <td> <button class="btn btn-danger px-2 py-0" type="button" data-type="minus" (click)="removeProduct(product)">-</button></td>
          </tr>
          }
          @if(order.total && order.total>0){
            <tr style="border-top-width: 1px;">
              <td> </td>
              <td> </td>
              <td>Total: </td>
              <td>{{order.total}} </td>
              <td> </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <br>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col">
        <button class="btn btn-primary btn-block w-100" type="button" (click)="close()">
          Cancel
        </button>
      </div>
      <div class="col">
        <button class="btn btn-primary btn-block w-100" type="button" (click)="createOrUpdateOrder()">
          Send payment link
        </button>
      </div>
    </div>
  </div>
</div>
<app-loader [loading]="isLoading"></app-loader>